import localesEn from '@/shared/i18n/AuthB2C/en';
import { LOGIN_PAGE_KEY } from '@/views/Login/constants';

const en = {
  [LOGIN_PAGE_KEY]: {
    ...localesEn,
    SEO_TITLE: 'Log In',
    SEO_DESCRIPTION: 'Log in and learn new skills today.',
    FORM_TITLE: 'Welcome back',
    FORM_DESCRIPTION: 'We are happy to see you again :)',
    FORM_TITLE_RENOVATION: 'You have a surprise waiting!',
    FORM_DESCRIPTION_RENOVATION: 'Log in to your account to see it',
    INPUT_EMAIL_LABEL: 'Email',
    INPUT_EMAIL_HINT: 'Enter your email',
    INPUT_PASSWORD_LABEL: 'Password',
    INPUT_PASSWORD_HINT: 'Enter your password',
    FORGOT_PASSWORD: 'Forgot password?',
    BUTTON_SUBMIT_LABEL: 'Log in',
    FIRST_TIME_IN_CREHANA: 'Is this your first time using Crehana?',
    REGISTER: 'Register',
    LOGIN_WITH_YOUR_ORGANIZATION: 'Log in with your organization',
    LOGIN_WITH_YOUR_ORGANIZATION_DESKTOP: 'Log in with your organization',
  },
};

export default en;
